import react from "react";
import Women from './cultureImage/Women.jpg'
import Foundation from './cultureImage/2025-1_Foundation_Day_01.jpg'
import ChristmasCelebration from './cultureImage/ChristmasCelebration.jpg'
import Diwali from './cultureImage/Celebration-7-year.jpg'
import GaneshUtsav from './cultureImage/GaneshUtsav.jpg'
import MensDayCelebration from './cultureImage/MensDayCelebration.jpg'
import WomensDay from './cultureImage/Women’s.jpg'
import Holi from './cultureImage/Holi .jpg'
import IndependenceDay from './cultureImage/Independence .jpg'
import yogaDay from './cultureImage/yoga.jpg'

const Celebrating = () => {
    return (
        <div className="font-recoleta">
            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12 font-recoleta'>🎄✨ Christmas Vibes at TekIT Software Solutions! 🎅🎁</h1>
            <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4 font-recoleta'>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>We brought the holiday spirit alive at TekIT with a jolly celebration full of fun, games, and festive cheer! From a surprise visit by Santa to exciting games like Secret Santa, Santa Tambola, and the super-fun Guess the Item by Song Name, the energy was infectious!🎉</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>A cozy office party added the perfect finishing touch – great conversations, lots of laughter, and unforgettable memories. ❤️🎉</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>Spreading smiles, sharing gifts, and making memories – that’s how we celebrated the season of joy at TekIT! ✨🎁

                    </p> 
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4 font-recoleta'>Here’s to celebrating teamwork, joy, and the little moments that make TekIT special!
                    </p>
                </div>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-left" src={ChristmasCelebration} className=' w-full' />

                </div>
            </div>
            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>🪔 Diwali Dhamaka at TekIT Software Solutions! 🪔</h1>
            <div className='lg:flex mt-12'>
                <div className='lg:w-[45%] w-full'>
                    <img src={Diwali} data-aos="fade-right" className=' w-full' />

                </div>
                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>This Diwali, our workplace turned into a vibrant hub of lights, laughter, and tradition! ✨
                        We celebrated the festival with full spirit and sparkle, embracing every moment with joy.</p>
                    <p data-aos="fade-left" className='2xl:text-[22px] font-semibold  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        Highlights of the day included
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4 '>
                        🌼 Office Pooja to welcome peace and prosperity
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>
                        🍱 An extravagant Chappan Bhog
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>
                        👒 Traditional attire that lit up the office
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>
                        🍽️ Scrumptious festive delicacies
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>
                        🎨 Vibrant Rangoli creations
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>
                        💐 Floral decor and sparkling lights that transformed our workspace
                    </p>
                    <p className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>It was truly a day to remember—filled with smiles, good vibes, and festive cheer. 💫
                    </p>
                </div>

            </div>
            


            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>🎉 Ganesh Utsav at TekIT Software Solutions Pvt. Ltd. 🎉</h1>
            <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>From Ganesh Sthapana to Ganesh Visarjan, the next 10 days are going to be full of divine energy, cultural vibes, and vibrant celebrations at TekIT! 🌟!</p>
                    <p data-aos="fade-right" className='2xl:text-[22px] font-semibold  lg:text-[14px] text-[34px] space-y-10 mt-4'>Here’s what makes this celebration special for us</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>🎭 Daily Themes to dress up and show your creativity</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'> 👕 Color Codes to brighten up the workplace</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'> 🍽️ Prashad Seva to share and enjoy delicious treats</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-4'>🪔 Aarti and Bhajans to start each day with devotion</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>Let’s welcome Ganpati Bappa with open hearts and celebrate this beautiful journey together as one family.</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>🙏 Ganpati Bappa Morya! Mangal Murti Morya! 🙏</p>
                </div>
                <div className='lg:w-[45%] w-full'>
                    <img src={GaneshUtsav} data-aos="fade-left" className='p-4 w-full' />

                </div>
            </div>

            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'> 🎊 A Day Just for the Gentlemen – Men’s Day Celebration! 💙</h1>
            <div className='lg:flex mt-12'>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-right" src={MensDayCelebration} className=' w-full' />

                </div>
                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10f'>A big shoutout to our incredible male colleagues! 💪</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>What a fantastic day it was! Our incredible ladies went the extra mile to make Men’s Day truly special — surprising the men of our team with thoughtful handwritten notes and a celebration full of laughter, energy, and joy! ✍️🎉</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>From meaningful messages to cheerful moments, the day was a reminder of how much we value the presence, perseverance, and positivity our male colleagues bring to the table every day.</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'> To the amazing men on our team — thank you for being your awesome selves. Here’s to you! 🙌👏</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>Cheers to the incredible men who help make our workplace complete! 🙌💙</p>
                </div>
            </div>

            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-8 text-center mt-12'>💐 Celebrating the Power of Women International Women’s Day 💐</h1>
            <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10'>This 8th March, we proudly celebrate International Women’s Day by honoring the incredible</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>women who inspire, lead, and create change every day. 💜
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>Focusing on women’s health, recognizing achievements, and promoting equality — because empowered women empower the world. 🌍✨
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'> Our male colleagues added a special touch with fun celebrations, sweet treats, and heartfelt appreciation.</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'> Here’s to celebrating womanhood — today and always! 💖:</p>
                    {/* <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>🎈 Organizing a fun-filled celebration</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>🍬 Distributing chocolates and goodies</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>🙏 Sharing thoughtful gestures of appreciation with our female teammatesfamily.</p> */}

                </div>
                <div className='lg:w-[45%] w-full'>
                    <img src={WomensDay} data-aos="fade-left" className='w-full' />

                </div>

            </div>
            {/* <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>Let’s join hands to celebrate womanhood and continue to uplift and support each other — today and always. 💖</p>
            <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>Let’s make this celebration meaningful by acknowledging, appreciating, and supporting the incredible women around us — today and every day! 💜</p> */}

            {/* <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>🌟 Appreciation Day – March 8th 🌟</h1>
            <div className='lg:flex mt-12'>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-right" src={Foundation} className='p-2 w-full' />

                </div>
                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>We took a moment on March 8th to celebrate our greatest asset — our amazing team! 💼💪</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        The Appreciation Day was filled with smiles, laughter, and well-deserved recognition. We proudly handed out awards and rewards to recognize the exceptional efforts and achievements of our colleagues. 🏅👏
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        To top it off, we hosted a small party with good food, music, and great company — a perfect way to unwind and celebrate together. 🎊🍕🎶
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        Thank you to everyone for your dedication and passion — you make the workplace truly special. Here's to many more milestones together! 🚀
                    </p>
                </div>

            </div> */}
            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>Holi celebration 🌈</h1>
            <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>Holi was a burst of joy and color! 🌈 From playful gulal fights to dancing under the open sky, the energy was unmatched. The table was loaded with mouthwatering traditional food—crispy gujiyas, spicy samosas, and creamy thandai. 🥟🍹</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        Sweet treats and goodies made their way to everyone’s hands (and hearts!). 💝 It was a perfect blend of fun, food, and festive cheer—a day to remember forever! 💃✨
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        The aroma of traditional delicacies filled the air, while laughter echoed all around. We shared stories, sweets, and smiles—celebrating not just the festival, but the beautiful bonds we cherish. 🌸
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        It was a day of pure celebration, where traditions met togetherness, and colors spoke the language of love. 🎨✨
                    </p>
                </div>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-left" src={Holi} className=' w-full' />

                </div>
            </div>
            {/* <h1 className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>Remote Employee Engagement</h1> */}
            {/* <div className='lg:flex mt-12'>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-right" src={Foundation} className='p-4 w-full' />

                </div>
                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>Distance doesn’t stop us from staying connected! 🌍</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        We believe in creating memorable experiences for our remote employees through engaging team-building activities. Whether it's a festival, milestone, or special day — we make it extra special with vouchers, goodies, health benefits , and plenty of smiles. Because every team member matters, no matter where they are!
                    </p>

                </div>

            </div> */}
            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>The Independence Day  and Republic Day</h1>
            <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-right" className='2xl:text-[22px] lg:text-[14px] text-[34px] space-y-10 '>We came together to celebrate our nation with pride and gratitude. 🇮🇳</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                    The day began with the flag hoisting and National Anthem — a heartfelt tribute to our heroes.
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                    Dressed in tricolor, we enjoyed tasty treats, fun games, and cheerful moments that brought everyone closer.
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>
                    A beautiful reminder of unity, culture, and the joy of being Indian. Jai Hind! ✨

                    </p>
                    {/* <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>
                        🍽️ Tasty treats,
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>
                        🎯 Fun games,
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10'>
                        🎉 And cheerful moments with everyone made it a day to remember.
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        It was a beautiful reminder of unity, culture, and the joy of being part of something bigger than ourselves — our India. Jai Hind!
                    </p> */}

                </div>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-left" src={IndependenceDay} className=' w-full' />

                </div>
            </div>
            <h1 data-aos="fade-up" className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12'>. 🌿 International Day of Yoga 🌿</h1>
            <div className='lg:flex mt-12'>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-right" src={yogaDay} className='p-4 w-full' />

                </div>
                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>🌼 Breathe. Stretch. Smile. 🌼</p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-1'>
                        To honor the essence of wellness and mindfulness, we celebrated International Day of Yoga with a rejuvenating Yoga Session right here at our office! 🧘‍♀️✨
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-1'>
                        We invited a professional Yoga Trainer who guided us through a series of energizing and calming yoga techniques — a much-needed pause from our busy schedules.
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px] font-semibold lg:text-[20px] text-[34px] space-y-10 mt-1'>
                        It was the perfect opportunity to
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ Stretch and move
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ De-stress and recharge
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ Boost energy and focus at work
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ Improve posture and flexibility
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ Reduce stress and anxiety
                    </p>
                    <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-4 '>
                        ✅ Reignite focus and productivity
                    </p>
            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>
                The session left us feeling refreshed, recharged, and more connected — mind, body, and soul. 🧘‍♂️💼
            </p>
                </div>

            </div>

            {/* <h1 data-aos="fade-up" className='text-[#F86F4B] lg:text-[32px] text-[54px] font-bold px-14 text-center mt-12'>🎉 Birthday and Anniversary Celebrations 🎉</h1> */}
            {/* <div className='lg:flex mt-12'>

                <div className='lg:w-[55%] content-center w-full p-4'>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 '>We believe in celebrating every special moment of our team members!
                        To honor the birthdays and work anniversaries of our employees, we host small celebrations that include cake cutting and heartfelt gestures of appreciation.</p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        It's our way of showing gratitude and making these milestones memorable! 🥳🎂🎈
                    </p>
                    <p data-aos="fade-right" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>
                        Let’s continue to grow, celebrate, and create joyful memories together!
                    </p>

                </div>
                <div className='lg:w-[45%] w-full'>
                    <img data-aos="fade-left" src={Foundation} className='p-4 w-full' />

                </div>
            </div> */}
        </div>
    )
}
export default Celebrating;